// loading
export const SHOW_LOADING = 'SHOW_LOADING'
export const HIDE_LOADING = 'HIDE_LOADING'

// messages
export const PUSH_MESSAGE = 'PUSH_MESSAGE'
export const POP_MESSAGE = 'POP_MESSAGE'

// current location
export const SET_CURRENT_POINT_AND_LOCATION = 'SET_CURRENT_POINT_AND_LOCATION'
export const SET_CURRENT_POINT = 'SET_CURRENT_POINT'
export const SET_CURRENT_LOCATION = 'SET_CURRENT_LOCATION'
export const SET_CURRENT_TIMEZONE = 'SET_CURRENT_TIMEZONE'

// map
export const SET_CENTER_POINT = 'SET_CENTER_POINT'
export const SET_MARKER_ID = 'SET_MARKER_ID'

// search

export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT'
export const CLEAR_SEARCH = 'CLEAR_SEARCH'

// auth
export const RECEIVE_USER_ON_STATE_CHANGED = 'RECEIVE_USER_ON_STATE_CHANGED'
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'
export const SIGN_IN_ERROR = 'SIGN_IN_ERROR'
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS'
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS'
export const SIGN_UP_ERROR = 'SIGN_UP_ERROR'
export const SEND_PASSWORD_RESET_EMAIL_SUCCESS =
  'SEND_PASSWORD_RESET_EMAIL_SUCCESS'
export const SEND_EMAIL_VERIFICATION_SUCCESS = 'SEND_EMAIL_VERIFICATION_SUCCESS'
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS'
export const UPDATE_PASSWORD_ERROR = 'UPDATE_PASSWORD_ERROR'
export const UPDATE_EMAIL_SUCCESS = 'UPDATE_EMAIL_SUCCESS'
export const UPDATE_EMAIL_ERROR = 'UPDATE_EMAIL_ERROR'
export const UPDATE_USER_PROFILE_PHOTO_URL_SUCCESS =
  'UPDATE_USER_PROFILE_PHOTO_URL_SUCCESS'
export const UPDATE_USER_PROFILE_PHOTO_URL_ERROR =
  'UPDATE_USER_PROFILE_PHOTO_URL_ERROR'
export const UPDATE_USER_PROFILE_PHOTO_URL_TEMP =
  'UPDATE_USER_PROFILE_PHOTO_URL_TEMP'

// profile
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS'
export const RECEIVE_PROFILE_FROM_SNAPSHOT = 'RECEIVE_PROFILE_FROM_SNAPSHOT'

// reviews
export const GET_REVIEWS_SUCCESS = 'GET_REVIEWS_SUCCESS'
export const GET_REVIEW_SUCCESS = 'GET_REVIEW_SUCCESS'
export const ADD_REVIEW_SUCCESS = 'ADD_REVIEW_SUCCESS'
export const ADD_REVIEW_ERROR = 'ADD_REVIEW_ERROR'



// WEBPACK FOOTER //
// ./src/store/actions/actionTypes/index.js